import React from 'react'
import {cx} from '@emotion/css'

interface Props {
  size?: number
}

export const LoggedPersonIcon = ({size = 20}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={cx(
      'box-border',
      'rounded-full',
      'size-600',
      'min-h-600',
      'min-w-600'
    )}
    data-test="TopNav-AccountIcon"
  >
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g fill="#E8EDF1" transform="translate(-80 -82)">
        <g>
          <g transform="translate(80 82)">
            <g>
              <g>
                <path d="M32 0c17.664 0 32 14.336 32 32S49.664 64 32 64 0 49.664 0 32 14.336 0 32 0zm.005 36.683c-12.56 0-21.333 6.578-21.333 16l.115.53.35.345c11.617 11.249 30.104 11.25 41.723.003l.353-.348.126-.53-.003-.307c-.188-9.257-8.905-15.693-21.33-15.693zm0-24c-5.882 0-10.666 4.786-10.666 10.666 0 5.88 4.786 10.667 10.666 10.667 5.883 0 10.667-4.787 10.667-10.667s-4.784-10.666-10.667-10.666z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
